import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Parallax} from 'react-parallax';

require("../css/pagetitle.css");

class PageTitle extends Component {
    render() {
        const insideStyles = { padding: 20, position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%,-50%)' };
        return (
            <div style={{marginBottom:80}}>
                <Parallax bgImage={this.props.bgimgurl}
                    strength={400}>
                    <div style={{ height: 280 }}>
                        <div className="parallax-overlay">
                            <div style={insideStyles}>
                                <h1 className="h1-responsive mt-5 mb-2 wow fadeInDown pagetitle" data-wow-delay="0.3s">{this.props.title}</h1>
                                <div className="line"></div>
                            </div>
                        </div>
                    </div>
                </Parallax>
            </div>
        );
    }
}

PageTitle.propTypes = {
    title: PropTypes.string.isRequired,
    bgimgurl: PropTypes.string
};

export default PageTitle;


// WEBPACK FOOTER //
// ./src/components/PageTitle.js